// SPS tenant dark theme — colors sourced from Figma "Southern Pipe" design file (SPS Dark mode).
import { createTheme } from '@mui/material/styles';
import './tokens';

const spsDarkTheme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'dark',
    primary: {
      main: '#F75E56',
      contrastText: '#ffffff',
    },
    navigation: {
      background:        '#3d434b',
      subPanelBg:        '#464d57',
      divider:           'rgba(255, 255, 255, 0.12)',
      tabSelectedBg:     '#f75e56',
      tabSelectedBorder: 'transparent',
      link:              '#ff9a94',
      badge:             '#f73a5b',
      text:              '#ffffff',
      textMuted:         'rgba(255, 255, 255, 0.65)',
      subPanelText:      '#ffffff',
      subPanelTextMuted: 'rgba(255, 255, 255, 0.65)',
      subPanelAvatarBg:  'rgba(255, 255, 255, 0.2)',
    },
    surface: {
      appBackground:    '#464d57',
      chatPanelBg:      '#464d57',
      chatHeaderBg:     '#464d57',
      inputBg:          '#515964',
      inputBorder:      'rgba(255, 255, 255, 0.18)',
      inputBorderFocus: '#f75e56',
      inputText:        'rgba(255, 255, 255, 0.85)',
      divider:          'rgba(255, 255, 255, 0.08)',
      primaryText:      '#ffffff',
      secondaryText:    'rgba(255, 255, 255, 0.40)',
      emptyStateIcon:   'rgba(255, 255, 255, 0.40)',
      toastBg:          '#ffffff',
      toastText:        '#2a2e42',
    },
    chat: {
      userBubbleBg:          '#f75e56',
      userBubbleText:        '#ffffff',
      assistantBubbleBg:     '#464d57',
      assistantBubbleBorder: 'rgba(255, 255, 255, 0.10)',
      bubbleText:            '#ffffff',
      sentStatus:            'rgba(255, 255, 255, 0.40)',
      reactionAction:        'rgba(255, 255, 255, 0.60)',
      reactionActionHover:   '#ffffff',
      systemBubbleBg:        'rgba(255, 255, 255, 0.06)',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '.ndm-compose-input-wrapper': {
          background: '#ffffff !important',
        },
        '.ndm-compose-option-avatar': {
          backgroundColor: '#d9dce0 !important',
          color: '#2a2e42 !important',
        },
        '.ndm-compose-option-name': {
          color: '#181d27 !important',
        },
        '.ndm-compose-option-email': {
          color: '#8e97a3 !important',
        },
        '.ai-message .message, .assistant-message': {
          background: 'var(--mui-palette-chat-assistantBubbleBg) !important',
          borderColor: 'var(--mui-palette-chat-assistantBubbleBorder) !important',
          color: 'var(--mui-palette-chat-bubbleText)',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          color: '#2a2e42',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          color: '#1A1F2E',
          '& .MuiTypography-root': { color: '#1A1F2E' },
          '& .MuiInputLabel-root': { color: '#6B7280' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#f7433a' },
          '& .MuiInputBase-input': { color: '#1A1F2E' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d9dce0' },
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#8e97a3' },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#f7433a' },
          '& .MuiButton-text': { color: '#1A1F2E' },
          '& .MuiButton-text:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
          '& .MuiDivider-root': { borderColor: 'rgba(0,0,0,0.12)' },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#1A1F2E',
        },
      },
    },
  },
  typography: {
    fontFamily: "'Proxima Nova', sans-serif",
  },
});

export default spsDarkTheme;
